import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWorkoutPlanList } from "../../api/workoutPlanListApi";
import * as Endpoints from "../../entities/Endpoints";

export const fetchWorkoutPlanListThunk = createAsyncThunk(
  Endpoints.GET_WORKOUT_LIST,
  async ({ coachId, clientId }, { rejectWithValue }) => {
    try {
      const data = fetchWorkoutPlanList({ coachId, clientId });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const workoutPlanSlice = createSlice({
  name: "getWorkoutPlanList",
  initialState: {
    workoutPlanList: null,
    isloading: false,
    error: null,
    successMessage: null,
    updateSuccessMessage: "",
    updateFailedMessage: "",
  },
  reducers: {
    clearUpdateMessage: (state) => {
      state.updateSuccessMessage = "";
      state.updateFailedMessage = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkoutPlanListThunk.pending, (state) => {
        state.isloading = true;
        state.error = null;
      })
      .addCase(fetchWorkoutPlanListThunk.fulfilled, (state, action) => {
        state.isloading = false;
        state.workoutPlanList = action.payload;
        if (!action.payload.workoutPlans) {
          state.updateFailedMessage = "No workout plan found";
        }
      })
      .addCase(fetchWorkoutPlanListThunk.rejected, (state, action) => {
        state.isloading = false;
        state.error = action.payload;
      });
  },
});

export const workoutPlanListReducer = workoutPlanSlice.reducer;
